import styled from 'styled-components';
import { TextSkeleton } from '@cld/skeleton';

export const StyledHeaderSkeleton = styled(TextSkeleton)`
  margin: 0 ${(props) => props.theme.spacing.xs};
  width: auto;
  height: 32px;
`;
